import React from "react";
import { routes } from "./routes";
import { Routes, Route, BrowserRouter, useLocation } from "react-router-dom";
import { ProtectedRoute } from "./protected.route";
import { useAuth } from "../contexts/AuthContext";
// import { useWidget } from "../hooks/useWidget";
import { Layout } from "../components/Layout";
import Sso from "../pages/Sso";
import { motion } from "framer-motion";

const ssoPaths = ["/sso/callback", "/sso/complete"];
const layoutRoutes = routes.filter((route) => !ssoPaths.includes(route.path));

const NAV_ORDER = [
  "/listcourses",
  "/listcourses/progress",
  "/estudio",
  "/foro",
  "/contact",
];

const getNavIndex = (path) => {
  if (path.startsWith("/listcourses/progress")) return 1;
  if (path.startsWith("/listcourses")) return 0;
  if (path.startsWith("/estudio")) return 2;
  if (path.startsWith("/foro")) return 3;
  if (path.startsWith("/contact")) return 4;
  return -1;
};

const AnimatedLayoutRoutes = () => {
  const location = useLocation();
  const prevPathRef = React.useRef(location.pathname);

  const prevIndex = getNavIndex(prevPathRef.current);
  const currentIndex = getNavIndex(location.pathname);
  const isProfile = location.pathname.startsWith("/mi-cuenta");
  const wasProfile = prevPathRef.current.startsWith("/mi-cuenta");

  let variants;

  if (isProfile) {
    variants = {
      initial: { opacity: 0, y: 35 },
      animate: { opacity: 1, y: 0 },
      exit: { opacity: 0, y: -25 },
    };
  } else if (wasProfile) {
    variants = {
      initial: { opacity: 0, y: -25 },
      animate: { opacity: 1, y: 0 },
      exit: { opacity: 0, y: 35 },
    };
  } else if (
    prevIndex !== -1 &&
    currentIndex !== -1 &&
    prevIndex !== currentIndex
  ) {
    const direction = currentIndex > prevIndex ? 1 : -1;
    variants = {
      initial: { opacity: 0, x: direction * 45 },
      animate: { opacity: 1, x: 0 },
      exit: { opacity: 0, x: -direction * 45 },
    };
  } else {
    variants = {
      initial: { opacity: 0 },
      animate: { opacity: 1 },
      exit: { opacity: 0 },
    };
  }

  React.useEffect(() => {
    prevPathRef.current = location.pathname;
  }, [location.pathname]);

  return (
    <Layout>
      {/* Sin AnimatePresence mode="wait": con clics rápidos en el navbar la
          animación de salida podía quedar colgada y la página nueva nunca se
          montaba, dejando la pantalla en negro. Solo animamos la entrada. */}
      <motion.div
        key={
          location.pathname.startsWith("/foro") ? "/foro" : location.pathname
        }
        initial={variants.initial}
        animate={variants.animate}
        transition={{ duration: 0.24, ease: "easeOut" }}
        style={{ width: "100%", minHeight: "100%" }}
      >
        <Routes location={location}>
          {layoutRoutes.map((route, idx) => {
            const Element = route.requireAuth ? (
              <ProtectedRoute>
                <route.element />
              </ProtectedRoute>
            ) : (
              <route.element />
            );

            return <Route key={idx} path={route.path} element={Element} />;
          })}
        </Routes>
      </motion.div>
    </Layout>
  );
};

const CustomRoutes = () => {
  const auth = useAuth();

  React.useEffect(() => {
    auth.dictionary();
    // eslint-disable-next-line
  }, []);

  React.useEffect(() => {
    async function VerifyAuth() {
      try {
        await auth.Authenticate();
      } catch (error) {
        console.error("Error during VerifyAuth:", error);
      }
    }
    if (!auth.user) {
      VerifyAuth();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/sso/callback" element={<Sso />} />
        <Route path="/sso/complete" element={<Sso />} />
        <Route path="*" element={<AnimatedLayoutRoutes />} />
      </Routes>
    </BrowserRouter>
  );
};

export default CustomRoutes;
